import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {
    catchError,
    map,
    mergeMap,
} from 'rxjs/operators';
import { DealService } from '../../services/deal.service';
import {
    LoadDealCardsBidResultsFail,
    LoadDealCardsBidResultsSuccess,
    LoadDealCardsBidResults,
    DealCardsBidResultsActionTypes
} from './actions';

@Injectable()
export class DealCardsBidResultsEffects {
    @Effect()
    public loadDealCardsBidResults$: Observable<LoadDealCardsBidResultsSuccess | LoadDealCardsBidResultsFail> = this.actions$.pipe(
        ofType(DealCardsBidResultsActionTypes.LoadDealCardsBidResults),
        mergeMap((action: LoadDealCardsBidResults) =>
            this.dealService.getBidResults(action.payload).pipe(
                map(({bidResult}) =>
                    new LoadDealCardsBidResultsSuccess(action.payload, bidResult)
                ),
                catchError(error => of(new LoadDealCardsBidResultsFail(action.payload, error.message)))
            )
        )
    );

    constructor(
        public dealService: DealService,
        private actions$: Actions
    ) {
    }
}
